export default "__VITE_ASSET__2f9525d5__"